import ShowCompanyInformation from "./ShowInformation/Company.ShowInformation";
import ShowDriverInformation  from "./ShowInformation/Driver.ShowInformation" ;
import ClosedFactorModal      from "./ClosedFactor"                           ;
import ApproveDocuments       from "./ApproveDocuments"                       ;
import TransferAcademicYear   from './TransferAcademicYear'                   ;
import RemoveIsArchive        from './RemoveIsArchive'                        ;
import ShowAllService         from "./ShowAllService"                         ;
import PayAllServices         from "./PayAllServices"                         ;
import ShowBlockInfo          from "./ShowBlockInfo"                          ;
import Settelment             from "./Settelment"                             ;
import Favorite               from './Favorite'                               ;
import Approve                from "./Approve"                                ;
import UnBlock                from "./UnBlock"                                ;
import Deposit                from "./Deposit"                                ;
import Create                 from "./Create"                                 ;
import Search                 from "./Search"                                 ;
import Filter                 from "./Filter"                                 ;
import Update                 from "./Update"                                 ;
import Block                  from "./Block"                                  ;
import Body                   from "./Body"                                   ;

type TypeComponents = {
  ShowCompanyInformation: typeof ShowCompanyInformation;
  ShowDriverInformation : typeof ShowDriverInformation ;
  ClosedFactorModal     : typeof ClosedFactorModal     ;
  ApproveDocuments      : typeof ApproveDocuments      ;
  TransferAcademicYear  : typeof TransferAcademicYear  ;
  RemoveIsArchive       : typeof RemoveIsArchive       ;
  ShowAllService        : typeof ShowAllService        ;
  PayAllServices        : typeof PayAllServices        ;
  ShowBlockInfo         : typeof ShowBlockInfo         ;
  Settelment            : typeof Settelment            ;
  Favorite              : typeof Favorite              ;
  Approve               : typeof Approve               ;
  UnBlock               : typeof UnBlock               ;
  Deposit               : typeof Deposit               ;
  Create                : typeof Create                ;
  Search                : typeof Search                ;
  Filter                : typeof Filter                ;
  Update                : typeof Update                ;
  Block                 : typeof Block                 ;
  Body                  : typeof Body                  ;
}

const Components: TypeComponents = {
  ShowCompanyInformation,
  ShowDriverInformation ,
  ClosedFactorModal     ,
  ApproveDocuments      ,
  TransferAcademicYear  ,
  RemoveIsArchive       ,
  ShowAllService        ,
  PayAllServices        ,
  ShowBlockInfo         ,
  Settelment            ,
  Favorite              ,
  Approve               ,
  UnBlock               ,
  Deposit               ,
  Create                ,
  Search                ,
  Filter                ,
  Update                ,
  Block                 ,
  Body                  ,
};

export default Components;
